<template>
  <div class='appointBox' style='width: calc(95% - 200px);'>
    <div class='eq_header'>
      <div style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
        仪器预约</div>
      <span style='font-size:14px;color:#999999'>您的位置：个人中心><span style="color:#188335">预约记录</span></span>
    </div>
    <div style='width: 100%;'>
      <div class='sdau_search'>
        <el-form ref="form" :model="formData" label-width="100px" :inline="true">
          <el-row>
            <el-col :span='8'>
              <el-form-item label="预约申请日期">
                <el-date-picker @change="handleTime" v-model="dateRange" size="small" value-format="yyyy-MM-dd"
                  type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="截止日期"
                  clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约单号">
                <el-input placeholder="请输入设预约单号" v-model="formData.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约审核状态" prop="userName">
                <el-select style="width:100%" placeholder="预约审核状态" v-model="formData.statusList">
                  <el-option v-for="(item, index) in statusData" :key="index" :label="item.name" :value="item.status">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约人姓名">
                <el-input placeholder="请输入预约人姓名" v-model="formData.reservationUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约人学号">
                <el-input placeholder="请输入预约人学号" v-model="formData.reservationUserStudentNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" :index='Nindex' width="55" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="code" width="100" label="预约单号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentNumber" width="100" label="设备编号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentName" width="100" label="设备名称" align="center">
        </el-table-column>
        <el-table-column prop="equipmentTypeName" width="100" label="设备分类" align="center">
        </el-table-column>
        <el-table-column prop="reservationUserName" width="100" label="预约人姓名" align="center">
        </el-table-column>
        <el-table-column prop="reservationUserStudentNo" width="120" label="预约人学号" align="center">
        </el-table-column>
        <el-table-column prop="status" width="140" label="预约审核状态" align="center">
          <template slot-scope="scope">
            <span v-for='(item, index) in statusData' :key='index'>
              <span v-if='scope.row.status == item.status && !scope.row.abnormalStatus'>{{ item.name }}</span>
            </span>
            <span v-if='scope.row.abnormalStatus'>异常</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" width="140" label="预约申请日期" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationStartTime" width="140" label="预约起始时间" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationEndTime" width="140" label="预约截止时间" align="center">
        </el-table-column>
        <el-table-column prop="reservationDuration" width="100" label="预约时长" align="center">
          <template slot-scope="scope">
            <span v-if='scope.row.reservationDuration'>{{ scope.row.reservationDuration + '分钟' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reservationCount" width="100" label="预约件数" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button v-if='scope.row.status == "1" && scope.row.afterEndTime == "0"' style='color:#FF9131' type="text"
              size="small" @click="showdelappoints(scope.row)">取消预约</el-button>
            <el-button
              v-if='[3, 4, "3", "4", 2, "2"].includes(scope.row.status) || ([0, "0", 1, "0"].includes(scope.row.status) && scope.row.afterEndTime == "1")'
              type="text" size="small" @click="appointagain(scope.row)">再次预约</el-button>
            <el-button v-if='scope.row.status == "2"' type="text" size="small"
              @click="showMessage(scope.row, 0)">查看审批意见</el-button>
            <el-button v-if='scope.row.status == "3"' type="text" size="small"
              @click="showMessage(scope.row, 1)">查看取消原因</el-button>
            <span v-if='[0, 5, "0", "5"].includes(scope.row.status)'>暂无操作</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
        :limit.sync="formData.pageSize" @pagination='init' />
    </div>
    <appointmentDialog v-if="showDelappoint" :showDelappoint='showDelappoint' @cancel="cancel" :dialogTitle="dialogTitle"
      :dialogStatus='dialogStatus' :cantreason='cantreason' :appointId='appointId' />
  </div>
</template>
<script>
import appointmentDialog from './dialog/appointmentDialog.vue'
export default {
  props: {},
  components: {
    appointmentDialog
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
      },
      total: 1,
      pageSizes: [5, 10, 20, 50, 100, 300],
      tableData: [],
      dateRange: [],
      statusData: [
        {
          name: "待审核",
          status: "0",
        },
        {
          name: "已审核",
          status: "1",
        },
        {
          name: "已驳回",
          status: "2",
        },
        {
          name: "已取消",
          status: "3",
        },
        {
          name: "已完成",
          status: "4",
        },
        {
          name: "已开始",
          status: "5",
        }
      ],
      showDelappoint: false,
      reason: "",
      appointId: '',
      dialogStatus: '',
      dialogTitle: '',
      cantreason: '',
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.dateRange = []
      this.init()
    },
    handleTime(date) {
      if (date) {
        this.formData.createTimeStart = date[0]
        this.formData.createTimeEnd = date[1]
      } else {
        this.formData.createTimeStart = []
        this.formData.createTimeEnd = []
      }
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    cancel() {
      this.showDelappoint = false
      this.init()
    },
    init() {
      this.$net(`/sdau/deviceReservation/queryMyReservationList`, 'get', this.formData).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.rows
          this.total = res.data.total
        }
      })
    },
    showdelappoints(row) {
      this.dialogStatus = 10
      this.dialogTitle = '取消预约'
      this.appointId = row.id
      this.showDelappoint = true
    },
    appointagain(row) {
      this.$net(`/v1/billing/scheme/querySchemeByEquipmentId/${row.equipmentId}`, 'get').then(res => {
        this.$router.push({
          path: '/appointment',
          query: {
            id: row.equipmentId,
            billingMethod: res.data.billingMethod
          }
        })
      }).catch(err => {

      })
    },
    showMessage(row, status) {
      this.dialogTitle = status == 0 ? '审批意见' : '取消原因'
      this.cantreason = status == 0 ? row.auditRemark : row.cancelReason
      this.dialogStatus = status
      this.showDelappoint = true
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}

.eq_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>